<template>
  <div class="page">
    <div class="page__bd">
      <div class="x-card" v-if="type == '注销备案'">
        <h5 class="x-card-title">清算组备案信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ initData.detailPage.name }}</p>
          <span class="x-card-content-title">统一社会信用代码/工商注册号</span>
          <p>{{ initData.detailPage.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ initData.detailPage.registrationOrgan }}</p>
          <span class="x-card-content-title">清算组备案日期</span>
          <p>{{ initData.detailPage.filingDate }}</p>
          <span class="x-card-content-title">清算组成立日期</span>
          <p>{{ initData.detailPage.establishmentDate }}</p>
          <span class="x-card-content-title">注销原因</span>
          <p>{{ initData.detailPage.reason }}</p>
          <span class="x-card-content-title">清算组办公地址</span>
          <p>{{ initData.detailPage.address }}</p>
          <span class="x-card-content-title">清算组联系电话</span>
          <p>{{ initData.detailPage.phone }}</p>
          <span class="x-card-content-title">清算组负责人</span>
          <p>{{ initData.detailPage.dutyer }}</p>
          <span class="x-card-content-title">清算组成员</span>
          <p>{{ initData.detailPage.member }}</p>
        </div>
        <h5 class="x-card-title">债权人公告信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ initData.detailPage.creName }}</p>
          <span class="x-card-content-title">统一社会信用代码/工商注册号</span>
          <p>{{ initData.detailPage.creUniSocCreIdentifier }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ initData.detailPage.creRegistrationOrgan }}</p>
          <span class="x-card-content-title">公告期</span>
          <p>{{ initData.detailPage.creAnnouncementDate }}</p>
          <span class="x-card-content-title">公告内容</span>
          <p>{{ initData.detailPage.creAnnouncementContent }}</p>
          <span class="x-card-content-title">公告状态</span>
          <p>{{ initData.detailPage.creAnnouncementStatus }}</p>
          <span class="x-card-content-title">债权申报联系人</span>
          <p>{{ initData.detailPage.creDeclarePerson }}</p>
          <span class="x-card-content-title">债权申报联系电话</span>
          <p>{{ initData.detailPage.creDeclarePhone }}</p>
          <span class="x-card-content-title">债权申报地址</span>
          <p>{{ initData.detailPage.creDeclareAddress }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '简易注销'">
        <h5 class="x-card-title">企业公告信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ initData.detailPage.name }}</p>
          <span class="x-card-content-title">统一社会信用代码/工商注册号</span>
          <p>{{ initData.detailPage.uniSocCreIdentifier }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ initData.detailPage.registrationOrgan }}</p>
          <span class="x-card-content-title">公告期</span>
          <p>{{ initData.detailPage.announcementDate }}</p>
        </div>
        <h5 class="x-card-title">简易注销结果</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">简易注销结果</span>
          <p>{{ initData.detailPage.result }}</p>
          <span class="x-card-content-title">公告申请日期</span>
          <p>{{ initData.detailPage.announcementApplyDate }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '清算信息'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">清算组负责人</span>
          <p>{{ initData.listPage.dutyer }}</p>
          <span class="x-card-content-title">清算组成员</span>
          <p>{{ initData.listPage.member }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '严重违法'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">列入日期</span>
          <p>{{ initData.listPage.inclusionDate }}</p>
          <span class="x-card-content-title">列入严重违法失信企业名单原因</span>
          <p>{{ initData.listPage.reason }}</p>
          <span class="x-card-content-title">列入决定机关</span>
          <p>{{ initData.listPage.decisionOrgans }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '环保处罚'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">决定书文号</span>
          <p>{{ initData.listPage.decisionNumber }}</p>
          <span class="x-card-content-title">违反法律</span>
          <p>{{ initData.listPage.lawbreaking ? initData.listPage.lawbreaking : '-' }}</p>
          <span class="x-card-content-title">处罚依据	</span>
          <p>{{ initData.listPage.penaltyAccording ? initData.listPage.penaltyAccording :'-'}}</p>
          <span class="x-card-content-title">处罚结果	</span>
          <p>{{ initData.listPage.penaltyResult ? initData.listPage.penaltyResult :'-' }}</p>
          <span class="x-card-content-title">处罚日期	</span>
          <p>{{ initData.listPage.penaltyDate }}</p>
          <span class="x-card-content-title">处罚单位	</span>
          <p>{{ initData.listPage.penaltyUnit }}</p>
          <span class="x-card-content-title">执行情况	</span>
          <p>{{ initData.listPage.executeStatus ? initData.listPage.executeStatus: '-' }}</p>
          <span class="x-card-content-title">处罚事由	</span>
          <p>{{ initData.listPage.penaltyReason ? initData.listPage.penaltyReason :'-' }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '税收违法'">
        <h5 class="x-card-title">注册信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">纳税人名称</span>
          <p>{{ initData.detailPage.taxpayerName }}</p>
          <span class="x-card-content-title">纳税人识别号</span>
          <p>{{ initData.detailPage.taxRegistrationNumber }}</p>
          <span class="x-card-content-title">组织机构代码</span>
          <p>{{ initData.detailPage.orgInsBarCode ? initData.detailPage.orgInsBarCode :'-' }}</p>
          <span class="x-card-content-title">注册地址</span>
          <p>{{ initData.detailPage.registeredAddress }}</p>
        </div>
        <h5 class="x-card-title">案件信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.detailPage.caseReleaseDate }}</p>
          <span class="x-card-content-title">案件性质</span>
          <p>{{ initData.detailPage.caseNatureCase }}</p>
          <span class="x-card-content-title">所属税务机关</span>
          <p>{{ initData.detailPage.caseTaxOrgans }}</p>
          <span class="x-card-content-title">主要违法事实</span>
          <p>{{ initData.detailPage.caseIllegalFacts }}</p>
          <span class="x-card-content-title">相关法律依据及税务处理处罚情况</span>
          <p>{{ initData.detailPage.casePenaltySituation }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '欠税公告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">企业名称</span>
          <p>{{ initData.detailPage.name }}</p>
          <span class="x-card-content-title">纳税人类型</span>
          <p>{{ initData.detailPage.taxpayerType ? initData.detailPage.taxpayerType : '-' }}</p>
          <span class="x-card-content-title">纳税人识别号</span>
          <p>{{ initData.listPage.taxRegistrationNumber }}</p>
          <span class="x-card-content-title">负责人姓名</span>
          <p>{{ initData.detailPage.dutyerName }}</p>
          <span class="x-card-content-title">证件号码</span>
          <p>{{ initData.detailPage.idNumber }}</p>
          <span class="x-card-content-title">经营地点</span>
          <p>{{ initData.detailPage.businessLocation ? initData.detailPage.businessLocation :'-' }}</p>
          <span class="x-card-content-title">欠税税种</span>
          <p>{{ initData.listPage.arrearsCategories ? initData.listPage.arrearsCategories :'-' }}</p>
          <span class="x-card-content-title">欠税余额(元)</span>
          <p>{{ initData.listPage.arrearsBalance }}</p>
          <span class="x-card-content-title">当前新发生的欠税金额(元)</span>
          <p>{{ initData.listPage.newArrearsBalance }}</p>
          <span class="x-card-content-title">发布单位</span>
          <p>{{ initData.listPage.taxAuthority }}</p>
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.listPage.releaseDate }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '经营异常'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">列入日期</span>
          <p>{{ initData.listPage.inclusionDate }}</p>
          <span class="x-card-content-title">作出决定机关</span>
          <p>{{ initData.listPage.decisionOrgans }}</p>
          <span class="x-card-content-title">列入经营异常名单原因</span>
          <p>{{ initData.listPage.reason }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '产品召回' || type == '政府约谈'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <h5 class="news-title">{{ form.title }}</h5>
          <span class="news-date">{{ form.news_date }}</span>
          <p class="news-content" v-html="form.content"></p>
        </div>
      </div>
      <div class="x-card" v-if="type == '土地抵押'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">宗地标识</span>
          <p>{{ initData.detailPage.landParcelID ? initData.detailPage.landParcelID :'-' }}</p>
          <span class="x-card-content-title">	宗地编号</span>
          <p>{{ initData.detailPage.landParcelNumber }}</p>
          <span class="x-card-content-title">所在行政区</span>
          <p>{{ initData.detailPage.administratively }}</p>
          <span class="x-card-content-title">土地面积</span>
          <p>{{ initData.detailPage.landArea }}</p>
          <span class="x-card-content-title">宗地座落</span>
          <p>{{ initData.detailPage.location }}</p>
          <span class="x-card-content-title">土地他项权利人证号</span>
          <p>{{ initData.detailPage.landObligeeNumber }}</p>
          <span class="x-card-content-title">土地使用权证号</span>
          <p>{{ initData.detailPage.landRightUseNumber }}</p>
          <span class="x-card-content-title">土地抵押人名称</span>
          <p>{{ initData.detailPage.landMortgageName }}</p>
          <span class="x-card-content-title">土地抵押人性质</span>
          <p>{{ initData.detailPage.landMortgageNature ? initData.detailPage.landMortgageNature : '-' }}</p>
          <span class="x-card-content-title">土地抵押权人</span>
          <p>{{ initData.detailPage.landMortgagee }}</p>
          <span class="x-card-content-title">抵押土地用途</span>
          <p>{{ initData.detailPage.landUse }}</p>
          <span class="x-card-content-title">抵押土地权属性质与使用权类型</span>
          <p>{{ initData.detailPage.natureAndRightUseType }}</p>
          <span class="x-card-content-title">	抵押面积</span>
          <p>{{ initData.detailPage.mortgageArea }}</p>
          <span class="x-card-content-title">	评估金额</span>
          <p>{{ initData.detailPage.assessAmount }}</p>
          <span class="x-card-content-title">	抵押金额</span>
          <p>{{ initData.detailPage.mortgageAmount }}</p>
          <span class="x-card-content-title">	土地抵押登记起始时间</span>
          <p>{{ initData.detailPage.mortgageStartTime }}</p>
          <span class="x-card-content-title">	土地抵押结束时间</span>
          <p>{{ initData.detailPage.mortgageEndTime }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '股权出质'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">股权出质设立登记日期</span>
          <p>{{ initData.detailPage.pledgedRecordDate }}</p>
          <span class="x-card-content-title">登记编号</span>
          <p>{{ initData.detailPage.registNumber }}</p>
          <span class="x-card-content-title">出质股权数额</span>
          <p>{{ initData.detailPage.pledgedAmount ? initData.detailPage.pledgedAmount :'-' }}</p>
          <span class="x-card-content-title">状态</span>
          <p>{{ initData.detailPage.status }}</p>
          <span class="x-card-content-title">出质人</span>
          <p>{{ initData.detailPage.pledgor ? initData.detailPage.pledgor : '-'}}</p>
          <span class="x-card-content-title">出质人证件号码</span>
          <p>{{ initData.detailPage.pledgorIDNumber }}</p>
          <span class="x-card-content-title">出质股权标的企业</span>
          <p>{{ initData.detailPage.pledgedEnterprise }}</p>
          <span class="x-card-content-title">质权人</span>
          <p>{{ initData.detailPage.pledgee }}</p>
          <span class="x-card-content-title">质权人证件号码</span>
          <p>{{ initData.detailPage.pledgeeIDNumber }}</p>
          <span class="x-card-content-title">备注</span>
          <p>{{ initData.detailPage.remark }}</p>
          <span class="x-card-content-title">数据来源</span>
          <p>{{ initData.detailPage.dataSources }}</p>

        </div>
      </div>
      <div class="x-card" v-if="type == '股权质押'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">质押人</span>
          <p>{{ initData.detailPage.pledgor }}</p>
          <span class="x-card-content-title">质押人参股企业</span>
          <p>{{ initData.detailPage.pledgorEnterprise }}</p>
          <span class="x-card-content-title">质押股份数量(股)</span>
          <p>{{ initData.detailPage.pledgedSharesNum ? initData.detailPage.pledgedSharesNum :'-' }}</p>
          <span class="x-card-content-title">质押股份市值(元)</span>
          <p>{{ initData.detailPage.pledgedSharesMarketValue }}</p>
          <span class="x-card-content-title">占所持股份比例</span>
          <p>{{ initData.detailPage.ratioShares ? initData.detailPage.ratioShares : '-'}}</p>
          <span class="x-card-content-title">占总股本比例</span>
          <p>{{ initData.detailPage.totalRatioShares }}</p>
          <span class="x-card-content-title">质押权人</span>
          <p>{{ initData.detailPage.pledgee }}</p>
          <span class="x-card-content-title">质押原因</span>
          <p>{{ initData.detailPage.pledgedReason }}</p>
          <span class="x-card-content-title">质押目的</span>
          <p>{{ initData.detailPage.pledgedPurpose }}</p>
          <span class="x-card-content-title">质押日收盘价(元)</span>
          <p>{{ initData.detailPage.closingPrice }}</p>
          <span class="x-card-content-title">预警线(估算)</span>
          <p>{{ initData.detailPage.alertLine }}</p>
          <span class="x-card-content-title">平仓线(估算)</span>
          <p>{{ initData.detailPage.closePositionLine }}</p>
          <span class="x-card-content-title">质押开始日期</span>
          <p>{{ initData.detailPage.pledgedStartDate }}</p>
          <span class="x-card-content-title">质押解除日期</span>
          <p>{{ initData.detailPage.pledgedEndDate }}</p>
          <span class="x-card-content-title">状态</span>
          <p>{{ initData.detailPage.status }}</p>
          <span class="x-card-content-title">公告日期</span>
          <p>{{ initData.detailPage.announcementDate }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '对外担保'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">担保方</span>
          <p>{{ initData.detailPage.guarantor }}</p>
          <span class="x-card-content-title">被担保方</span>
          <p>{{ initData.detailPage.byGuarantor }}</p>
          <span class="x-card-content-title">公告日期</span>
          <p>{{ initData.detailPage.announcementDate ? initData.detailPage.announcementDate :'-' }}</p>
          <span class="x-card-content-title">担保方式</span>
          <p>{{ initData.detailPage.guarantyStyle }}</p>
          <span class="x-card-content-title">担保金额</span>
          <p>{{ initData.detailPage.guarantyMoney ? initData.detailPage.guarantyMoney : '-'}}</p>
          <span class="x-card-content-title">币种</span>
          <p>{{ initData.detailPage.currency }}</p>
          <span class="x-card-content-title">担保期限</span>
          <p>{{ initData.detailPage.guarantyDeadline ? initData.detailPage.guarantyDeadline :'-' }}</p>
          <span class="x-card-content-title">担保起始日</span>
          <p>{{ initData.detailPage.guarantyStartDate ? initData.detailPage.guarantyStartDate: '-' }}</p>
          <span class="x-card-content-title">担保终止日</span>
          <p>{{ initData.detailPage.guarantyEndDate ? initData.detailPage.guarantyEndDate :'-' }}</p>
          <span class="x-card-content-title">是否履行完毕</span>
          <p>{{ initData.detailPage.completed }}</p>
          <span class="x-card-content-title">是否关联交易</span>
          <p>{{ initData.detailPage.relatedTrade }}</p>
          <span class="x-card-content-title">交易日期</span>
          <p>{{ initData.detailPage.tradeDate ? initData.detailPage.tradeDate :'-' }}</p>
          <span class="x-card-content-title">报告期</span>
          <p>{{ initData.detailPage.reportPeriod ? initData.detailPage.reportPeriod :'-' }}</p>
          <span class="x-card-content-title">报告类别</span>
          <p>{{ initData.detailPage.reportType ? initData.detailPage.reportType :'-' }}</p>
          <span class="x-card-content-title">担保事件说明</span>
          <p>{{ initData.detailPage.guarantyExplanation ? initData.detailPage.guarantyExplanation:'-' }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '动产抵押'">
        <h5 class="x-card-title">动产抵押登记信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">登记编号</span>
          <p>{{ initData.detailPage.registNumber }}</p>
          <span class="x-card-content-title">登记机关</span>
          <p>{{ initData.detailPage.registrationOrgan }}</p>
          <span class="x-card-content-title">登记日期</span>
          <p>{{ initData.detailPage.recordDate}}</p>
        </div>
        <h5 class="x-card-title">抵押权人信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">抵押权人名称</span>
          <p>{{ initData.detailPage.mortgagee }}</p>
          <span class="x-card-content-title">抵押权人证照类型</span>
          <p>{{ initData.detailPage.mortgageeIDType }}</p>
          <span class="x-card-content-title">证照号码</span>
          <p>{{ initData.detailPage.idNumber }}</p>
        </div>
        <h5 class="x-card-title">被担保主债权信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">种类</span>
          <p>{{ initData.detailPage.byGuaranteedDebtType }}</p>
          <span class="x-card-content-title">数额</span>
          <p>{{ initData.detailPage.byGuaranteedDebtAmount }}</p>
          <span class="x-card-content-title">债务人履行债务期限</span>
          <p>{{ initData.detailPage.debtMaturities ? initData.detailPage.debtMaturities : '-' }}</p>
          <span class="x-card-content-title">担保的范围</span>
          <p>{{ initData.detailPage.guaranteeScope ? initData.detailPage.guaranteeScope : '-' }}</p>
          <span class="x-card-content-title">备注</span>
          <p>{{ initData.detailPage.remark }}</p>
        </div>
        <h5 class="x-card-title">抵押物信息</h5>
        <div class="x-card-content" v-for="(item,index) in initData.detailPage.guaranteeInfo" :key="index">
          <span class="x-card-content-title">名称</span>
          <p>{{ item.name }}</p>
          <span class="x-card-content-title">所有权或使用权归属</span>
          <p>{{ item.ownership }}</p>
          <span class="x-card-content-title">数量、质量、状况、所在地等情况</span>
          <p>{{ item.condition }}</p>
          <span class="x-card-content-title">备注</span>
          <p>{{ item.remark ? item.remark : '-'}}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '劳动仲裁'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.detailPage.releaseDate }}</p>
          <span class="x-card-content-title">申请人</span>
          <p>{{ initData.detailPage.applicant}}</p>
          <span class="x-card-content-title">被申请人</span>
          <p>{{ initData.detailPage.defendingApplicant}}</p>
          <span class="x-card-content-title">原文</span>
          <p>{{ initData.detailPage.originalText }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '开庭公告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">主案由</span>
          <p>{{ initData.detailPage.mainSuit }}</p>
          <span class="x-card-content-title">申请人</span>
          <p>{{ initData.detailPage.applicant}}</p>
          <span class="x-card-content-title">被申请人</span>
          <p>{{ initData.detailPage.defendingApplicant }}</p>
          <span class="x-card-content-title">仲裁员</span>
          <p>{{ initData.detailPage.arbitrator }}</p>
          <span class="x-card-content-title">书记员</span>
          <p>{{ initData.detailPage.secretary }}</p>
          <span class="x-card-content-title">地点</span>
          <p>{{ initData.detailPage.place }}</p>
          <span class="x-card-content-title">发布机构</span>
          <p>{{ initData.detailPage.organizations }}</p>
          <span class="x-card-content-title">开庭时间</span>
          <p>{{ initData.detailPage.courtDate }}</p>
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.detailPage.releaseDate }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '公示催告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">票据号</span>
          <p>{{ initData.detailPage.billNumber }}</p>
          <span class="x-card-content-title">申请人</span>
          <p>{{ initData.detailPage.applicant }}</p>
          <span class="x-card-content-title">出票人</span>
          <p>{{ initData.detailPage.drawer ? initData.detailPage.drawer : '-'}}</p>
          <span class="x-card-content-title">持票人</span>
          <p>{{ initData.detailPage.bearer }}</p>
          <span class="x-card-content-title">票据类型</span>
          <p>{{ initData.detailPage.billType }}</p>
          <span class="x-card-content-title">票面金额</span>
          <p>{{ initData.detailPage.billAmount }}</p>
          <span class="x-card-content-title">出票日</span>
          <p>{{ initData.detailPage.draftDate ? initData.detailPage.draftDate : '-' }}</p>
          <span class="x-card-content-title">到期日</span>
          <p>{{ initData.detailPage.maturityDate ? initData.detailPage.maturityDate : '-' }}</p>
          <span class="x-card-content-title">付款银行</span>
          <p>{{ initData.detailPage.payingBank }}</p>
          <span class="x-card-content-title">类别</span>
          <p>{{ initData.detailPage.type }}</p>
          <span class="x-card-content-title">公告日期</span>
          <p>{{ initData.detailPage.announcementDate }}</p>
          <span class="x-card-content-title">公告内容</span>
          <p>{{ initData.detailPage.content }}</p>
        </div>
      </div>
      <div class="x-card" v-if="type == '违规处理'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">公告日期</span>
          <p>{{ initData.detailPage.announcementDate }}</p>
          <span class="x-card-content-title">处罚对象</span>
          <p>{{ initData.detailPage.punishPerson }}</p>
          <span class="x-card-content-title">类型</span>
          <p>{{ initData.detailPage.type}}</p>
          <span class="x-card-content-title">处分类型</span>
          <p>{{ initData.detailPage.punishType }}</p>
          <span class="x-card-content-title">处理人</span>
          <p>{{ initData.detailPage.handler }}</p>
          <span class="x-card-content-title">处罚金额</span>
          <p>{{ initData.detailPage.punishAmount ? initData.detailPage.punishAmount : '-'}}</p>
          <span class="x-card-content-title">违规行为</span>
          <p>{{ initData.detailPage.illegalBehavior }}</p>
          <span class="x-card-content-title">处分措施</span>
          <p>{{ initData.detailPage.punishMeasure }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object,
    type: String
  },
  data() {
    return {
      form:{
      }
    };
  },
  created() {
    let me= this
    if(me.type == '政府约谈' ||  me.type == '产品召回'){
      me.loadData(me.initData.listPage.uuid);
    }
   
  },
  methods: {
    loadData(id) {
      let me = this
      if (!id) {
        return;
      }
      me.$loading({
        url: "/api/document/eOperatingRisk/getNews?uuid=" + id,
      }).then(function (res) {
        if (res.data) {
          me.form = res.data;
         
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  background: #fff;
  height: 100%;
}
.x-card-title {
  background: #f0f7fc;
  font-size: 16px;
  padding: 10px 10px;
  font-weight: 400;
  color: #0C88F1;

}
.x-card-content{
  padding: 4px 10px;
  font-size: 14px;
  color: #333;
}
.x-card-content-title{
  display: block;
  font-weight: bold;
  margin-top:10px !important;
}
.news-date{
  display: block;
  font-size: 12px;
  color: #8890a5;
 text-align: center;
}
.news-title{
  margin: 10px 0px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.news-content{
  margin: 10px 0px;
  font-size: 14px;
  color: #333;
  text-indent: 20px;
}
</style>